import { CircularProgressProps } from '@mui/material/CircularProgress';
import { LinearProgressProps, linearProgressClasses } from '@mui/material/LinearProgress';
import { Theme, alpha } from '@mui/material/styles';

// ----------------------------------------------------------------------

const COLORS = ['primary', 'secondary', 'info', 'success', 'warning', 'error'] as const;

export function progress(theme: Theme) {
  return {
    // LINEAR PROGRESS
    MuiLinearProgress: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: LinearProgressProps }) => {
          const isInherit = ownerState.color === 'inherit';

          return {
            height: 8,
            borderRadius: 100, // Pill shape
            backgroundColor: isInherit ? alpha(theme.palette.common.white, 0.24) : theme.palette.background.neutral,
            [`& .${linearProgressClasses.bar}`]: {
              borderRadius: 100,
            },
            // Genera dinamicamente i colori basati sulla palette V2
            ...COLORS.reduce(
              (acc, color) => ({
                ...acc,
                ...(ownerState.color === color && {
                  backgroundColor: alpha(theme.palette[color].main, 0.12),
                  [`& .${linearProgressClasses.bar}`]: {
                    backgroundColor: theme.palette[color].main,
                  },
                }),
              }),
              {},
            ),
          };
        },
      },
    },

    // CIRCULAR PROGRESS
    MuiCircularProgress: {
      styleOverrides: {
        root: ({ ownerState }: { ownerState: CircularProgressProps }) => ({
          // Gestione colori dinamica
          ...COLORS.reduce(
            (acc, color) => ({
              ...acc,
              ...(ownerState.color === color && {
                color: theme.palette[color].main,
              }),
            }),
            {},
          ),
        }),
        circle: {
          strokeLinecap: 'round',
        },
      },
    },
  };
}
